import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { viewCityList } from "../../Redux/Actions/settingsActions";
import { columnsCity } from "../../Global Functions/columnsAntd";
import TableComponent from "../../Global Functions/tableComponents";

const ListCity = () => {
  const { id } = useParams();

  // const STALE_TIME = process.env.REACT_APP_STALE_TIME;

  const dispatch = useDispatch();

  const { cities } = useSelector((state) => state.city);
  const { states, loading } = useSelector((state) => state.states);
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  const foundState =
    Array.isArray(states?.data) && states.data.find((item) => item._id === id);

  const countryId = foundState?.country;

  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const cityData = {
      state: id,
      country: countryId,
      page: 1,
      limit: 200,
    };
    dispatch(viewCityList(cityData));
  }, [dispatch, id, countryId]);

  return (
    <TableComponent
      columns={columnsCity(canEdit)}
      buttonhead="Go Back"
      navigateTo={`/state-list/${countryId}`}
      navigateTo2={canAdd ? `/city/${id}/add` : null}
      buttonhead2={canAdd ? "Add City" : null}
      setState={setSearchQuery}
      h3heading={foundState?.state_name || "No Data"}
      loading={loading}
      dataSource={Array.isArray(cities?.data) ? cities.data : ""}
    ></TableComponent>
  );
};

export default ListCity;
